import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class HashService {

  constructor() { }

  generateUniqueHash(): string {
    const array = new Uint8Array(32); // 32 bytes for a secure hash
    crypto.getRandomValues(array);
    const randomInput = Array.from(array, byte => String.fromCharCode(byte)).join('');
    const uniqueHash = CryptoJS.SHA256(randomInput).toString(CryptoJS.enc.Hex);
    return uniqueHash;
  }
}
